// extracted by mini-css-extract-plugin
export default {"fs":"_2bfa69c544 d60b2ba437"};